// import './App.css';
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import Sidebar from "./components/header/Sidebar";
import { BrowserRouter as Router } from "react-router-dom";
import { DataManagerContextProvider } from "./context/DataManagerContext";
import AuthContextProvider from "./context/AuthContext";
import TransferContextProvider from "./context/TransferContext";

import { SnackbarProvider } from "notistack";

import {
  unstable_createMuiStrictModeTheme as createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
const theme = createMuiTheme({
  typography: {
    // allVariants: {
    //   color: "#464141",
    // },
    // fontFamily: ["Open Sans", "sans-serif"].join(","),
    // h4: {
    //   fontSize: "2rem",
    //   fontWeight: 600,
    //   padding: "0 0 20px 0",
    //   textAlign: "center",
    //   lineHeight: 1.5,
    // },
    h3: {
      fontSize: "2.5rem",
      // fontWeight: 600,
    },
    h4: {
      fontSize: "2rem",
    },
    h5: {
      fontWeight: 600,
    },
    subtitle2: {
      fontWeight: 600,
      fontSize: "1.125rem",
    },
    // subtitle2: {
    //   fontSize: "1.1rem",
    // },
  },
  palette: {
    primary: {
      main: "#9c3836",
    },
    // secondary: {
    //   main: "#8A8C90",
    // },
  },
});

const useStyles = makeStyles(() => ({
  backgroundStyle: {
    height: "100%",
    background: "#FAFAFC",
  },
}));

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
axios.defaults.headers.common["Content-Type"] = "application/json";

function App() {
  const classes = useStyles();
  return (
    <div className={classes.backgroundStyle}>
      <SnackbarProvider>
        <AuthContextProvider>
          <TransferContextProvider>
            <DataManagerContextProvider>
              <Router>
                <ThemeProvider theme={theme}>
                  <Sidebar />
                </ThemeProvider>
              </Router>
            </DataManagerContextProvider>
          </TransferContextProvider>
        </AuthContextProvider>
      </SnackbarProvider>
    </div>
  );
}

export default App;
